import { localDatabaseUrls } from "../backend/constants";
  import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
  import { getAPI } from "../backend/commons";
  import AlertManager from "../shared/Alert/Alert";

  export const getLandedCostVendorHistory = async () => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
      window.location.href = "/";
      return [];
    }

    const apiUrl =
  `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostUploadHistory}`;
    const response = await getAPI(apiUrl, tokenInfo);

    if (response && response.status === 200) {
      return response.json();
    }

    const error = await response?.json?.().catch(() => ({}));
    AlertManager.error(error?.message || "Unable to load landed cost upload history.");
    return [];
  };